import { Link } from "react-router-dom";
import Seo from "../components/Seo.jsx";
import { TOOLS } from "../data/tools.js";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Página no encontrada — tu-kit.com"
        description="La página que buscas no existe. Consulta el listado de calculadoras disponibles."
        path="/404"
        noindex
      />
      <section className="mx-auto max-w-2xl py-20 text-center">
        <p className="font-mono text-6xl font-extrabold acento">404</p>
        <h1 className="mt-4 text-2xl font-bold text-[color:var(--texto)]">Esta calculadora no existe</h1>
        <p className="mt-2 texto-2">
          Puede que el enlace esté mal escrito o que la herramienta haya cambiado de dirección.
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {TOOLS.filter((t) => !t.seo.noindex)
            .slice(0, 6)
            .map((t) => (
              <Link
                key={t.id}
                to={`/${t.slug}`}
                className="borde texto-2 rounded-full border px-3.5 py-1.5 text-sm font-medium transition hover:border-[color:var(--color-marca-300)] hover:text-[color:var(--acento-texto)]"
              >
                {t.name}
              </Link>
            ))}
        </div>

        <Link
          to="/"
          className="mt-8 inline-block rounded-lg bg-[color:var(--acento)] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[color:var(--acento)]"
        >
          Ver todas las herramientas
        </Link>
      </section>
    </>
  );
}
